import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MDBBootstrapModulesPro, MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../../../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-modal-special-destination-how-to',
  templateUrl: './bary-modal-special-destination-how-to.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, MDBBootstrapModulesPro, BaryIconComponent],
})
export class BaryModalSpecialDestinationHowToComponent {
  readonly modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  @Output() closeEvent = new EventEmitter();

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick(): void {
    this.modalRef.hide();
  }
}
